import { render, staticRenderFns } from "./newNavBar.vue?vue&type=template&id=2ae2a3d1&scoped=true&"
import script from "./newNavBar.vue?vue&type=script&lang=js&"
export * from "./newNavBar.vue?vue&type=script&lang=js&"
import style0 from "./newNavBar.vue?vue&type=style&index=0&id=2ae2a3d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae2a3d1",
  null
  
)

export default component.exports